export default __webpack_public_path__ + "static/media/logoH.57cf506a.png";